import { render, staticRenderFns } from "./r-smart-offer-bundle-sunken-ruins.vue?vue&type=template&id=7cee0a01"
import script from "./r-smart-offer-bundle-sunken-ruins.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-sunken-ruins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cee0a01')) {
      api.createRecord('7cee0a01', component.options)
    } else {
      api.reload('7cee0a01', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-sunken-ruins.vue?vue&type=template&id=7cee0a01", function () {
      api.rerender('7cee0a01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-sunken-ruins/r-smart-offer-bundle-sunken-ruins.vue"
export default component.exports